/**
 * Chubby's Chow - Custom Header JavaScript
 * Handles: Mobile menu, Search drawer, Sticky header, Account dropdown
 */

(function() {
  'use strict';

  // ========================================
  // STICKY HEADER ON SCROLL
  // ========================================
  
  const header = document.querySelector('.header--sticky');
  
  if (header) {
    let lastScroll = 0;
    
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      
      lastScroll = currentScroll;
    });
  }

  // ========================================
  // MOBILE MENU TOGGLE
  // ========================================
  
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  
  function openMobileMenu() {
    mobileNav.classList.add('active');
    mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  function closeMobileMenu() {
    mobileNav.classList.remove('active');
    mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', openMobileMenu);
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }
  
  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }

  // ========================================
  // MOBILE SUBMENU TOGGLE
  // ========================================
  
  const mobileMenuItems = document.querySelectorAll('.mobile-nav__item--has-submenu');
  
  mobileMenuItems.forEach(item => {
    const link = item.querySelector('.mobile-nav__link');
    const toggle = item.querySelector('.mobile-nav__toggle');
    
    if (toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        item.classList.toggle('open');
      });
    }
    
    // Prevent parent link navigation when has submenu
    if (link) {
      link.addEventListener('click', function(e) {
        if (item.classList.contains('mobile-nav__item--has-submenu')) {
          e.preventDefault();
          item.classList.toggle('open');
        }
      });
    }
  });

  // ========================================
  // SEARCH DRAWER
  // ========================================
  
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchClose = document.querySelector('[data-search-close]');
  
  function openSearchDrawer() {
    if (searchDrawer) {
      searchDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      // Focus on input
      setTimeout(() => {
        const searchInput = searchDrawer.querySelector('.search-drawer__input');
        if (searchInput) searchInput.focus();
      }, 300);
    }
  }
  
  function closeSearchDrawer() {
    if (searchDrawer) {
      searchDrawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  if (searchToggle) {
    searchToggle.addEventListener('click', openSearchDrawer);
  }
  
  if (searchClose) {
    searchClose.addEventListener('click', closeSearchDrawer);
  }
  
  if (searchDrawer) {
    searchDrawer.addEventListener('click', function(e) {
      if (e.target === searchDrawer) {
        closeSearchDrawer();
      }
    });
  }
  
  // Close search on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearchDrawer();
      closeMobileMenu();
    }
  });

  // ========================================
  // ANNOUNCEMENT BAR CLOSE
  // ========================================
  
  const announcementClose = document.querySelector('.announcement-bar__close');
  const announcementBar = document.querySelector('.announcement-bar');
  
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', function() {
      announcementBar.style.display = 'none';
      // Save to localStorage
      localStorage.setItem('announcementClosed', 'true');
    });
    
    // Check if previously closed
    if (localStorage.getItem('announcementClosed') === 'true') {
      announcementBar.style.display = 'none';
    }
  }

  // ========================================
  // CART COUNT UPDATE (AJAX)
  // ========================================
  
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          cartCount.textContent = data.item_count;
          
          if (data.item_count === 0) {
            cartCount.classList.add('hidden');
          } else {
            cartCount.classList.remove('hidden');
          }
        }
      })
      .catch(error => console.error('Cart update error:', error));
  }
  
  // Update cart count on page load
  updateCartCount();
  
  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);

  // ========================================
  // DROPDOWN KEYBOARD NAVIGATION
  // ========================================
  
  const menuItems = document.querySelectorAll('.header__menu-item--has-dropdown');
  
  menuItems.forEach(item => {
    const link = item.querySelector('.header__menu-link');
    const submenu = item.querySelector('.header__submenu');
    
    if (link && submenu) {
      link.addEventListener('keydown', function(e) {
        // Open on Enter or Space
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          submenu.style.opacity = '1';
          submenu.style.visibility = 'visible';
          submenu.style.transform = 'translateY(0)';
          
          // Focus first submenu link
          const firstLink = submenu.querySelector('.header__submenu-link');
          if (firstLink) firstLink.focus();
        }
      });
    }
  });

  // ========================================
  // PREVENT FLASH ON PAGE LOAD
  // ========================================
  
  window.addEventListener('DOMContentLoaded', function() {
    document.body.classList.add('loaded');
  });

})();